import { Const } from '../lib/const.cls'

export const getters = {

    [Const.GET_REGISTER_DATA]: (state) => {
        return state.registerData
    },
    [Const.GET_PAYU_REQUEST_INITIATE]: (state) => {
        return state.paymentData
    },
    [Const.GET_TIME_SLOTS]: (state) => {
        return state.timeSlots
    },
    

}



// WEBPACK FOOTER //
// ./src/plugins/giniView/provider/candle-history/store-addons/getters.js